export const gmbReviewLinkText = (url) => {
    return `<p><a href="${url}">${url}</a></p>`;
};
